
import { defineComponent, computed, ref } from 'vue'
import { SelectTypes } from 'ant-design-vue/es/select'
import { CloseOutlined } from '@ant-design/icons-vue'

export default defineComponent({
  name: 'FeedCompute',
  props: {
    result: Array
  },
  components: { CloseOutlined },
  emits: ['close'],
  setup(props, { emit }) {
    const visable = ref(true)
    const result = computed(() => props?.result || [0])
    const feedKcalUnit = ref(100)
    const kcalUnitOption = ref<SelectTypes['options']>([
      {
        label: '100g',
        value: 100
      },
      {
        label: '1000g',
        value: 1000
      }
    ])
    const feedKcal = ref(0)
    const count = ref(3)
    const total = computed(() => {
      if (typeof feedKcal.value !== 'number') return [0]
      if (!feedKcal.value || feedKcal.value <= 0) return [0]
      if (!result.value || typeof result.value?.[0] !== 'number') return [0]
      if (result.value?.[0] <= 0) return [0]
      const kcalUnit = Math.round(feedKcal.value / feedKcalUnit.value)
      if (kcalUnit <= 0) return [0]
      if (result.value.length === 2) {
        let limitResult: any = 0
        let maxResult: any = 0
        if (result.value?.[0]) limitResult = result.value[0]
        if (result.value?.[1]) maxResult = result.value[1]
        if (typeof limitResult === 'number' && typeof maxResult === 'number')
          return [Math.round(limitResult / kcalUnit), Math.round(maxResult / kcalUnit)]
        else if (typeof limitResult === 'number' && maxResult === '*')
          return [Math.round(limitResult / kcalUnit), '*']
        return [0]
      }
      if (result.value.length === 1 && typeof result.value[0] === 'number')
        return [Math.round(result.value[0] / kcalUnit)]
      return [0]
    })
    const meal = computed(() => {
      if (!total.value || typeof total.value?.[0] !== 'number') return [0]
      if (count.value <= 0 || typeof count.value !== 'number') return [0]
      if (total.value?.[0] <= 0) return [0]
      if (total.value.length === 2) {
        let limitTotal = total.value[0]
        let maxTotal = total.value[1]
        if (total.value?.[0]) limitTotal = total.value[0]
        if (total.value?.[1]) maxTotal = total.value[1]
        if (typeof limitTotal === 'number' && typeof maxTotal === 'number')
          return [Math.round(limitTotal / count.value), Math.round(maxTotal / count.value)]
        else if (typeof limitTotal === 'number' && maxTotal === '*')
          return [Math.round(limitTotal / count.value), '*']
        return [0]
      }
      if (total.value.length === 1)
        return [Math.round(total.value[0] / count.value)]
      return [0]
    })
    const handleClose = () => {
      emit('close')
    }
    const handleFocus = (e: any) => {
      e.target.select()
    }
    return {
      feedKcal,
      feedKcalUnit,
      kcalUnitOption,
      count,
      total,
      meal,
      visable,
      handleFocus,
      handleClose
    }
  }
})
